module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "Outdated"
  }, [_c('h2', [_vm._v("Web Browser ของคุณไม่รองรับการใช้งานเว็บไซต์นี้")]), _vm._v(" "), _c('p', [_vm._v("โปรดใช้ browser รุ่นใหม่ หรือถ้าใช้คุณกำลังใช้ in-app browser เช่นเปิดใน Line, Twitter หรือ Facebook กรุณาใช้ browser อื่นแทน เช่น Chrome หรือ Firefox เป็นต้น")]), _vm._v(" "), _c('a', {
    staticClass: "browser-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.close()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.$utils.svg(require('../assets/img/ic-close.svg')),
      "alt": "close",
      "width": "25",
      "height": "15"
    }
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cce9571","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Outdated.vue
// module id = 708
// module chunks = 1